import React, { useEffect, useState } from "react";
import "./BillingSimulator.css";
import { Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { pricePlanCalc } from "../../../services/utils";
import { InfoToolTip, PreLoader } from "../../../components";
import SimulatorSelect from "./common/SimulatorSelect/SimulatorSelect";
import PlanColumn from "../common/PlanColumn/PlanColumn";
import { getPlans } from "../../../services/api/credits.api";
import CustomPlan from "../common/PlanColumn/CustomPlanColumn";

export default function BillingSimulator(props) {
  const [plans, setPlans] = useState(null);
  const [plansToSimulate, setPlansToSimulate] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState("yearly");
  useEffect(() => {
    getPlans().then(({ data, statusCode }) => {
      if (statusCode === 200) {
        let selectedPlans = [
          ...data.plans.filter((plan) => plan.planId !== "0"),
        ];
        selectedPlans = selectedPlans.map((plan) => {
          plan.numberOfSeats = 1;
          return plan;
        });
        setPlansToSimulate(selectedPlans);
        setPlans(selectedPlans);
      }
    });
  }, []);
  const onSimulate = async (val) => {
    if (!plans) return;
    let currentPlans = Object.assign([], plans);
    currentPlans = currentPlans.map((plan, index) => {
      const numberOfSeats = val.id.split("_")[1];
      if (val.type == "by_user") {
        plan = {
          ...plan,
          pricePerSeat: numberOfSeats * plan.pricePerSeat,
          creditsPerSeat: numberOfSeats * plan.creditsPerSeat,
          numberOfSeats,
        };
      } else {
        plan = {
          ...plan,
          pricePerSeat:
            plan.planId == "plan_2"
              ? (numberOfSeats * plan.pricePerSeat) / 2
              : numberOfSeats * plan.pricePerSeat,
          creditsPerSeat:
            plan.planId == "plan_2"
              ? (numberOfSeats * plan.creditsPerSeat) / 2
              : numberOfSeats * plan.creditsPerSeat,
          notAvailable: plan.planId == "plan_2" && numberOfSeats % 2 !== 0,
          numberOfSeats:
            plan.planId == "plan_2" ? numberOfSeats / 2 : numberOfSeats,
        };
      }
      return plan;
    });
    setPlansToSimulate(currentPlans);
  };
  if (!plansToSimulate) return <PreLoader />;

  return (
    <>
      <Header isConnected={!!props.redux} />
      <div id={"simulator"}>
        <PlansTabs
          subscriptionType={subscriptionType}
          selectPlanDuration={setSubscriptionType}
          onSimulate={onSimulate}
        />
        <div className="subscription-tab-wrapper">
          <div className="tab-content">
            <div className="search-content-wrapper tab-pane active show">
              <Row>
                {plansToSimulate.map((plan, i) => (
                  <PlanColumn
                    key={i}
                    plan={plan}
                    subscriptionType={subscriptionType}
                    selectPlan={() => (window.location = "/billing")}
                    organizationCredits={null}
                    isSimulator
                  />
                ))}
                <CustomPlan />
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Header({ isConnected }) {
  if (isConnected) {
    return (
      <header className="signup-header" style={{ paddingLeft: 20 }}>
        <div className={"logo text-left"}>
          <a className="" href="/">
            <img
              src="/assets/images/logo_on_white.png"
              alt="logo"
              width="125"
            />
          </a>
        </div>
      </header>
    );
  }
  return (
    <header className="signup-header">
      <Container>
        <Row className="align-items-center">
          <Col>
            <div className={"logo text-left"}>
              <a className="" href="/">
                <img
                  src="/assets/images/logo_on_white.png"
                  alt="logo"
                  width="125"
                />
              </a>
            </div>
          </Col>
          <Col>
            <div className="header-right d-flex align-items-center justify-content-end">
              <p className="p16 p-color pr-3">
                <FormattedMessage id={"auth.haveAndAccount"} />
                <NavLink className="text-btn" exact to="/signin">
                  <FormattedMessage id={"auth.logIn"} />
                </NavLink>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </header>
  );
}
function PlansTabs({ subscriptionType, selectPlanDuration, onSimulate }) {
  const intl = useIntl();
  const [simulationType, setSimulationType] = useState("by_user");

  return (
    <div className={"tabs-container"}>
      <div>
        <div className="intro-title-wrap mt-16">
          <h6>
            <FormattedMessage id={"billing.pricingSimulator"} />
          </h6>
          <p>
            <FormattedMessage id={"billing.makeYourOwnPlan"} />
          </p>
        </div>
        <div className="subscription-tabs simulate">
          <ul className="nav nav-tabs" style={{ width: "490px" }}>
            <li onClick={() => setSimulationType("by_user")}>
              <a className={simulationType == "by_user" ? "active" : ""}>
                <FormattedMessage id={"billing.byUser"} />
              </a>
            </li>
            <li onClick={() => setSimulationType("by_credit")}>
              <a className={simulationType == "by_credit" ? "active" : ""}>
                <FormattedMessage id={"billing.byCredits"} />
              </a>
            </li>
          </ul>
          <SimulatorSelect
            simulationType={simulationType}
            subscriptionType={subscriptionType}
            onChange={onSimulate}
          />
        </div>
      </div>

      <div md={8} className="subscription-tabs">
        <ul className="nav nav-tabs" style={{ width: "490px" }}>
          <li onClick={() => selectPlanDuration("yearly")}>
            <a className={subscriptionType == "yearly" ? "active" : ""}>
              <FormattedMessage
                id={"billing.billAnnually"}
                values={{
                  span: (chunk) => <span> {chunk} </span>,
                }}
              />
            </a>
          </li>
          <li onClick={() => selectPlanDuration("monthly")}>
            <a className={subscriptionType == "monthly" ? "active" : ""}>
              <FormattedMessage id={"billing.billMonthly"} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
